__turbopack_context__.v({
  "error": "text-field-comment-module-scss-module__tkS1Bq__error",
  "errorText": "text-field-comment-module-scss-module__tkS1Bq__errorText",
  "label": "text-field-comment-module-scss-module__tkS1Bq__label",
  "row": "text-field-comment-module-scss-module__tkS1Bq__row",
  "textField": "text-field-comment-module-scss-module__tkS1Bq__textField",
});
